import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Avatar from '@material-ui/core/Avatar';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 295,
    width: 300,
    marginRight: 30
  },
  container: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  menuIcon: {
    textAlign: 'right'
  },
  icon: {
    color: '#8E8E8E',
    margin: 5,
    cursor: 'pointer'
  },
  avatar: {
    width: theme.spacing(8),
    height: theme.spacing(8)
  },
  title: {
    fontSize: 18,
    marginTop: 10,
    fontWeight: 'bold'
  },
  infos: {
    marginTop: 5,
    textAlign: 'center'
  },
  info: {
    fontSize: 16,
    color: '#6D7278',
    lineHeight: 1.4
  }
}));

const UserCard = ({ avatar, name, status, phone, email }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root} elevation={3}>
      <div className={classes.menuIcon}>
        <MoreHorizIcon className={classes.icon} />
      </div>
      <CardContent>
        <div className={classes.container}>
          <Avatar className={classes.avatar} src={avatar} />
          <Typography className={classes.title} gutterBottom variant="h3">
            {name}
          </Typography>
        </div>

        <div className={classes.infos}>
          <Typography className={classes.info} variant="h2">
            {status}
          </Typography>
          <Typography className={classes.info} variant="h2">
            {phone}
          </Typography>
          <Typography className={classes.info} variant="h2">
            {email}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserCard;
